import * as Yup from "yup";
import { validString } from "Components/shared/helpers/validations";
import { reverseShape } from "Helpers/reverse-shape";

const BaseFCFormSchema = {
  type: validString.required(),
  rackID: validString.optional(),
  daysToExpire: validString.required(),

  // mandatory here, but clear it in the model
  whitelist: Yup.array().min(1).required(),
};

const FCAddNewFormSchema = Yup.object().shape(reverseShape(BaseFCFormSchema));

export default FCAddNewFormSchema;
